module.exports = __webpack_public_path__ + "img/capc.4f3b314a.png";